<script>
import router from "../../router";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import moment from "moment";
export default {
  name: "PurchaseOrder",
  components: {
    Multiselect,
    DatePicker
  },
  data() {
    return {
      dateVal: new Date(),
      supplierList: [],
      itemList: [],
      storeList: [],
      selected_items: [],
      is_enable_b2b: false,
      filterObj: {
        store_id: "",
        supplier_id: "",
        status: "",
        is_b2b_store: false,
      },
      note_count: 0,
      order: {
        id: null,
        items: [],
        order_status: null,
        note: null,
        expected_on: null,
        purchase_date: null,
        total_amount: 0.0,
        additional_fees: [],
        store_id: null,
        is_enable_b2b: false,
        supplier_id: null
      },
      decimal_separator: ".",
precision: 0,
      disabledDates: {
        to: new Date()
      },
      additional_reasons: [
        "delivery_fee",
        "insurance",
        "other_cost",
      ]
    };
  },
  methods: {
    itemDetails(id, store_id) {
      return this.$api
        .getAPI({
          _action: `/item/detail/${id}?store_id=${store_id}`
        })
    },
    onSelectItem: async function (val) {
      if (this.filterObj.is_b2b_store) {
        // Get stock from supplier
        var sourceItemDetail = await this.itemDetails(val.id, this.filterObj.supplier_id)
        val.source_stock = sourceItemDetail.in_stock
      }
      this.selected_items.push(val)
      this.$_.remove(this.itemList, o => o.name === val.name)
      // Re-assign to update
      this.itemList = [...this.itemList]
    },
    onSupplierSelect() {
      this.itemList = []
      this.selected_items = []
      this.getItemList()
    },
    setSupplierName({ name }) {
      return name;
    },
    getSupplierList() {
      this.supplierList = [];
      if(!this.filterObj.is_b2b_store) {
        this.$api
          .getAPI({_action: "/supplier/list"})
          .then(res => {
            if (res.list != null && res.list.length > 0) {
              this.supplierList = res.list;
            }
          })
          .catch(e => {
          });
      }else{
        this.$api
          .getAPI({_action: "/store/list" + "?is_enable_b2b=0"})
          .then(res => {
            if (res.list != null && res.list.length > 0) {
              this.supplierList = res.list;
              this.$_.remove(this.supplierList, {id: this.filterObj.store_id});
            }
          })
          .catch(e => {
          });
      }
    },
    getItemList(deletedItem) {
      this.selected_items = [];
      this.itemList = [];
      this.$api
        .getAPI({ _action: "/item/purchase_order", _body: this.filterObj })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.itemList = res.list;
            this.$validator.reset();
            this.errors.clear();
            if(!!deletedItem){
              for(var i=0; i<deletedItem.length; i++){
                this.$_.remove(this.itemList, o => o.name === deletedItem[i].item.name)
              }
              this.itemList = [...this.itemList]
            }

          }
        })
        .catch(e => {});
    },

    onChangeStore(){
      this.filterObj.supplier_id = '';
      if (this.filterObj.store_id) {
        let stores = this.$_.filter(this.storeList, { id: this.filterObj.store_id })
        if(stores.length > 0) {
          this.filterObj.is_b2b_store = stores[0].is_enable_b2b && this.is_enable_b2b;
        }
      }
      this.getSupplierList()
      this.order.additional_fees = [];
      this.selected_items = [];
      this.setTotalAmount()
      this.itemList = [];

    },
    onTitleFeeSelect(index) {
      if(this.$_.filter(this.order.additional_fees, o => o.title == this.order.additional_fees[index].title).length > 1){
        this.order.additional_fees.splice(index)
        this.setTotalAmount()
      }
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    removeSelectedItem(index) {
      this.itemList.push(this.selected_items[index])
      this.selected_items.splice(index, 1);
      this.setTotalAmount()
    },
    calculateAmount(index) {
      if (
        this.selected_items[index].default_purchase_cost != null &&
        this.selected_items[index].default_purchase_cost > 0 &&
        this.selected_items[index].quantity != null &&
        this.selected_items[index].quantity > 0
      ) {
        this.selected_items[index].amount =
          this.selected_items[index].quantity *
          this.selected_items[index].default_purchase_cost;
        this.$set(this.selected_items, index, this.selected_items[index]);
      }
      this.setTotalAmount()
    },
    calculateAmount2(index) {
      this.selected_items[index].default_purchase_cost = this.selected_items[index].b2b_price
      if (
        this.selected_items[index].default_purchase_cost != null &&
        this.selected_items[index].default_purchase_cost > 0 &&
        this.selected_items[index].quantity != null &&
        this.selected_items[index].quantity > 0
      ) {
        this.selected_items[index].amount =
          this.selected_items[index].quantity *
          this.selected_items[index].default_purchase_cost;
        this.$set(this.selected_items, index, this.selected_items[index]);
      }
      this.setTotalAmount()
    },
    create(status) {
      if (status) {
        this.order.status = status;
      }
    },
    deleteAdditional(index) {
      this.order.additional_fees.splice(index, 1);
      this.setTotalAmount()
    },
    validateFilledValues(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (scope == "additional") {
            if (!this.order.additional_fees) {
              this.order.additional_fees = [];
            }
            var option = {
              title: "",
              cost: 0.0,
            };
            this.order.additional_fees.push(option);
          }
          return;
        }
      });
    },
    validateForm(status) {
      if (status) {
        this.order.order_status = status;
      }
      this.$validator.validateAll("additional").then(result => {
        if (result) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.save();
              return;
            }
          });
        }
      });
    },
    save() {
      this.order.supplier_id = this.filterObj.supplier_id
      this.order.store_id = this.filterObj.store_id
      this.order.is_enable_b2b = this.filterObj.is_b2b_store
      this.order.items = this.selected_items;
      this.order.purchase_date = moment(
        String(this.order.purchase_date)
      ).format("Y-M-D");
      if (this.order.expected_on) {
        this.order.expected_on = moment(String(this.order.expected_on)).format(
          "Y-M-D"
        );
      }
      this.$api
        .postAPI({
          _action: "/order/",
          _body: this.order,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/purchase-order");
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    setTotalAmount() {
      this.order.total_amount = 0.0;
      for (var i = 0; i < this.selected_items.length; i++) {
        if (this.selected_items[i].amount) {
          this.order.total_amount =
            this.order.total_amount * 1 + this.selected_items[i].amount * 1;
        }
      }
      for (var i = 0; i < this.order.additional_fees.length; i++) {
        if (this.order.additional_fees[i].cost) {
          this.order.total_amount =
            this.order.total_amount * 1 +
            this.order.additional_fees[i].cost * 1;
        }
      }
    },
    details(id) {
      this.order = {};
      this.selected_items = [];

      this.$api
        .getAPI({
          _action: "/order/detail/" + id
        })
        .then(res => {
          this.filterObj.is_b2b_store = !!!res.purchase_order.supplier_id
          this.filterObj.store_id = res.purchase_order.store_id
          if(!!!res.purchase_order.supplier_id){
            this.filterObj.supplier_id = res.purchase_order.source_b2b_store_id
          }else{
            this.filterObj.supplier_id = res.purchase_order.supplier_id
          }
          this.getSupplierList()
          this.getItemList(res.items)
          this.order = res.purchase_order;
          this.order.purchase_date = new Date(Date.parse(res.mail_purchase_date));
          if (res.mail_expected_on) {
            this.order.expected_on = new Date(Date.parse(res.mail_expected_on));
          }
          this.order.additional_fees = res.additional_fees;

          if (this.order.note) {
            this.note_count = this.order.note.length;
          }

          for (var i = 0; i < res.items.length; i++) {
            if (res.items[i].item) {
              this.selected_items.push(res.items[i].item);
            }
          }

          if (res.purchase_order.supplier_id != null) {
            for (var c5 = 0; c5 < this.supplierList.length; c5++) {
              if (this.supplierList[c5].id == res.purchase_order.supplier_id) {
                this.order.supplier_id = this.supplierList[c5].id;
                break;
              }
            }
          }
          this.filterObj.store_id = this.order.store_id;
        });
    },
    changeNoteCount() {
      if (this.note_count >= 300) {
        this.order.note = this.order.note.substring(0, 300);
        this.note_count = 300;
      }
      this.note_count = this.order.note.length;
    },
    checkdates() {
      var purchase_date = moment(String(this.order.purchase_date));
      var expected_on = moment(String(this.order.expected_on));

      if (expected_on < purchase_date) {
        this.order.expected_on = "";
        this.$notify({
          group: "foo",
          text: this.$lang.messages.expected_date_must_not_earlier_than_purchase_date,
          type: "error"
        });
        return false;
      }
    }
  },
  mounted() {
    var currentDate = new Date();
    currentDate.setHours(0,0,0,0);
    this.order.purchase_date = currentDate;
    this.getStoreList();
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;

    this.is_enable_b2b = localStorage.getItem('is_enable_b2b') == 'true' || false;
  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="row mb-4">
                  <div class="col-lg-6 mb-2">
                    <label for>{{$lang.messages.store}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd">
                      <select
                        v-model="filterObj.store_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.has('store_id') }"
                        @change="onChangeStore()"
                        v-validate="'required'"
                        name="store_id"
                      >
                        <option value>{{$lang.messages.select_store}}</option>
                        <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                      </select>
                      <i v-show="errors.has('store_id')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('store_id')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_store}}</span>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.supplier}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd">
                      <select
                        class="form-control"
                        :disabled="!!!this.filterObj.store_id"
                        v-model="filterObj.supplier_id"
                        @change="onSupplierSelect()"
                        :class="{'is-danger': !!filterObj.store_id && !filterObj.supplier_id }"
                        name="supplier_id"
                      >
                        <option value>{{$lang.messages.select_supplier}}</option>
                        <option v-for="obj in supplierList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                      </select>
                      <i v-show="!!filterObj.store_id && !filterObj.supplier_id" class="fa fa-warning"></i>
                      <span
                        v-show="!!filterObj.store_id && !filterObj.supplier_id"
                        class="help is-danger"
                      >{{$lang.messages.please_select_supplier}}</span>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-lg-6 mb-2">
                    <label for>{{$lang.messages.purchase_order_date}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="input-group">
                      <date-picker
                        name="purchase_date"
                        v-model="order.purchase_date"
                        style="width:430px;"
                        format="DD-MM-YYYY"
                        v-validate="'required'"
                        @change="checkdates()"
                        :class="['input w-xs-100', {'is-danger': errors.has('purchase_date') }]"
                        lang="en"
                      ></date-picker>

                      <i v-show="errors.has('purchase_date')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('purchase_date')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_purchase_date}}</span>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.expected_arrival_date}}</label>
                    <div class="input-group">
                      <date-picker
                        name="expected_on"
                        v-model="order.expected_on"
                        style="width:480px;"
                        format="DD-MM-YYYY"
                        @change="checkdates()"
                        :class="['input w-xs-100', {'is-danger': errors.has('expected_on') }]"
                        lang="en"
                      ></date-picker>
                      <i v-show="errors.has('expected_on')" class="fa fa-warning"></i>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <label for>{{$lang.messages.notes}}</label>
                    <label class="float-right">{{note_count}} / 300</label>
                    <textarea
                      class="form-control"
                      rows="1"
                      :placeholder="$lang.messages.write_here_something"
                      style="height: auto"
                      v-model="order.note"
                      maxlength="300"
                      v-on:keyup="changeNoteCount()"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9">
            <div class="card mb-0 rounded-5 border">
              <div class="card-header px-4 mt-1 py-3 bg-white border-bottom">
                <h3 class="font-22 d-inline-block">{{$lang.messages.items}}</h3>
                <div class="selectbox-xs custom-select-dd float-right" style="width: 275px"></div>
              </div>
              <div class="card-body form-style px-4">
                <div class="table-responsive">
                  <table class="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col" width="150">{{$lang.messages.item}}</th>
                        <th scope="col" width="120">{{$lang.messages.in_stock}}</th>
                        <th scope="col">{{$lang.messages.quantity}}</th>
                        <th v-if="!filterObj.is_b2b_store" scope="col">{{$lang.messages.purchase_cost}}</th>
                        <th v-else scope="col">{{$lang.messages.b2b_price}}</th>
                        <th scope="col">{{$lang.messages.amount}}</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sel, index)  in selected_items" :key="'composite_item_'+index">
                        <td class="align-middle">
                          <span class="f-semi-bold">{{sel.name}}</span>
                          <br />
                          <span v-if="sel.sku">{{$lang.messages.sku}} {{sel.sku}}</span>
                          <span
                            class="text-success"
                            v-if="sel.po_status == 'COMPLETED'"
                          >{{$lang.messages.received}}</span>
                        </td>
                        <td class="align-middle">{{sel.in_stock ? sel.in_stock: 0}}</td>
                        <!-- <td class="align-middle">{{sel.incoming ? sel.incoming: 0}}</td> -->
                        <td class="align-middle" v-if="sel.po_status != 'COMPLETED'">
                          <div v-if="!filterObj.is_b2b_store">
                            <input
                              placeholder="0.00"
                              type="text"
                              v-model="sel.quantity"
                              :id="'composite_item_quantity_' + index"
                              :name="'composite_item_quantity_' + index"
                              :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_quantity_' + index) }"
                              v-validate="'required|decimal|min_value:1'"
                              @keyup="calculateAmount(index)"
                            />
                            <i
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="fa fa-warning"
                            ></i>
                            <span
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="help is-danger"
                            >
                              {{$lang.messages.please_enter_valid_quantity}}
                            </span>
                          </div>
                          <div v-else>
                            <input
                              placeholder="0.00"
                              type="text"
                              v-model="sel.quantity"
                              :id="'composite_item_quantity_' + index"
                              :name="'composite_item_quantity_' + index"
                              :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_quantity_' + index) }"
                              v-validate="'required|decimal|min_value:1|max_value:' + sel.source_stock "
                              @keyup="calculateAmount2(index)"
                            />
                            <i
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="fa fa-warning"
                            ></i>
                            <span
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="help is-danger"
                            >
                              <div v-if="sel.source_stock <= 0">{{$lang.messages.this_item_is_out_of_stock}}</div>
                              <div v-else-if="sel.quantity > sel.source_stock">{{$lang.messages.only_in_stock.replace("QUANTITY", sel.source_stock)}}</div>
                              <div v-else>{{$lang.messages.please_enter_valid_quantity}}</div>
                            </span>
                          </div>
                        </td>
                        <td class="align-middle" v-else>
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.quantity"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_quantity_' + index) }"
                            readonly="true"
                          />
                        </td>
                        <td class="align-middle" v-if="sel.po_status != 'COMPLETED'">
                          <div v-if="!filterObj.is_b2b_store">
                            <input
                              placeholder="0.00"
                              type="text"
                              v-model="sel.default_purchase_cost"
                              :id="'composite_item_cost_' + index"
                              :name="'composite_item_cost_' + index"
                              :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_cost_' + index) }"
                              v-validate="'required|decimal'"
                              @keyup="calculateAmount(index)"
                            />
                            <i v-show="errors.has('composite_item_cost_'+ index)" class="fa fa-warning"></i>
                            <span
                              v-show="errors.has('composite_item_cost_'+ index)"
                              class="help is-danger"
                            >{{$lang.messages.please_enter_valid_cost}}</span>
                          </div>
                          <div v-else>
                            <input
                              placeholder="0.00"
                              type="text"
                              v-model="sel.b2b_price"
                              :disabled="true"
                              :id="'composite_item_cost_' + index"
                              :name="'composite_item_cost_' + index"
                              :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_cost_' + index) }"
                              v-validate="'required|decimal'"
                              @keyup="calculateAmount2(index)"
                            />
                            <i v-show="errors.has('composite_item_cost_'+ index)" class="fa fa-warning"></i>
                            <span
                              v-show="errors.has('composite_item_cost_'+ index)"
                              class="help is-danger"
                            >{{$lang.messages.please_enter_valid_cost}}</span>
                          </div>
                        </td>
                        <td class="align-middle" v-else>
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.cost"
                            readonly="true"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_cost_' + index) }"
                          />
                        </td>
                        <td class="align-middle">
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :value="sel.amount"
                            :read-only="true"
                          />
                        </td>
                        <td class="align-middle" v-if="sel.po_status != 'COMPLETED'">
                          <a href="javascript:void(0)" @click="removeSelectedItem(index)">
                            <i class="far fa-trash-alt font-20 text-danger"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div>
                      <label class="typo__label">{{$lang.messages.item_search}}</label>
                      <span style="color:#ff0000">*</span>
                      <multiselect
                        :disabled="!!!this.filterObj.store_id"
                        @select="onSelectItem"
                        :options="itemList"
                        :multiple="true"
                        :close-on-select="true"
                        :clear-on-select="false"
                        v-bind:placeholder="$lang.messages.please_select_option"
                        label="name"
                        track-by="name"
                        name="searchItem"
                        :select-label="$lang.messages.please_enter_to_select"
                        :deselect-label="$lang.messages.please_enter_to_remove"
                        :selected-label="$lang.messages.selected"
                      >
                        <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>
                        <template slot="selection">
                        </template>
                      </multiselect>

                      <i v-show="!!this.filterObj.store_id && selected_items.length <= 0" class="fa fa-warning"></i>
                      <span
                        v-show="!!this.filterObj.store_id && selected_items.length <= 0"
                        class="help is-danger"
                      >{{$lang.messages.please_select_atleast_one_item}}</span>
                    </div>
                  </div>
                </div>

                <div style="margin-top:30px;">
                  <div>
                    <h2>{{$lang.messages.additional_cost}}</h2>
                  </div>
                  <form data-vv-scope="additional">
                    <div
                      class="row mb-0"
                      v-for="(item, index) in order.additional_fees"
                      :key="item.id"
                    >
                      <div
                        class="col-lg-6 mb-lg-3 mb-2"
                        v-if="item.po_additional_status != 'COMPLETED'"
                      >
                        <label for>{{$lang.messages.title}}</label>
                        <div v-if="filterObj.is_b2b_store">
                          <select
                            v-model="item.title"
                            class="form-control"
                            :class="{ 'is-danger': errors.has('additional.title_'  +index) }"
                            v-validate="'required'"
                            :name="'title_'  +index"
                            :id="'title_'  +index"
                            @change="onTitleFeeSelect(index)"
                          >
                            <option v-for="obj in additional_reasons" :key="obj" :value="obj">{{ $lang.messages[obj] }}</option>
                          </select>
                          <i v-show="errors.has('additional.title_'  +index)" class="fa fa-warning"></i>
                          <span
                            v-show="errors.has('additional.title_'  +index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_title}}</span>
                        </div>
                        <div v-else>
                          <input
                            :id="'title_'  +index"
                            :name="'title_'  +index"
                            v-model="item.title"
                            v-validate="'required'"
                            class="form-control"
                            :class="{'input': true, 'is-danger': errors.has('additional.title_'  +index) }"
                            type="text"
                          />
                          <i v-show="errors.has('additional.title_'  +index)" class="fa fa-warning"></i>
                          <span
                            v-show="errors.has('additional.title_'  +index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_title}}</span>
                        </div>
                      </div>
                      <div class="col-lg-6 mb-lg-3 mb-2" v-else>
                        <label for>{{$lang.messages.title}}</label>
                        <input
                          :id="'title_'  +index"
                          :name="'title_'  +index"
                          v-model="item.title"
                          class="form-control"
                          :class="{'input': true, 'is-danger': errors.has('additional.title_'  +index) }"
                          type="text"
                          readonly="true"
                        />
                      </div>

                      <div class="col-lg-5 col-12" v-if="item.po_additional_status != 'COMPLETED'">
                        <label for>{{$lang.messages.cost}}</label>
                        <input
                          :id="'cost_'  +index"
                          :name="'cost_'  +index"
                          type="text"
                          class="form-control"
                          placeholder="0.00"
                          @keyup="setTotalAmount()"
                          v-model="item.cost"
                          v-validate="'required|decimal|min_value:1'"
                          :class="{'input': true, 'is-danger': errors.has('additional.cost_'  +index) }"
                        />
                        <i v-show="errors.has('additional.cost_'  +index)" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('additional.cost_'  +index)"
                          class="help is-danger"
                        >{{$lang.messages.please_enter_valid_cost}}</span>
                      </div>

                      <div class="col-lg-5 col-12" v-else>
                        <label for>{{$lang.messages.cost}}</label>
                        <input
                          :id="'cost_'  +index"
                          :name="'cost_'  +index"
                          type="text"
                          class="form-control w-xs-100"
                          placeholder="0.00"
                          v-model="item.cost"
                          readonly="true"
                          :class="{'input': true, 'is-danger': errors.has('additional.cost_'  +index) }"
                        />
                      </div>

                      <div
                        class="col-sm-1 text-right"
                        style="margin-top:40px;"
                        v-if="item.po_additional_status != 'COMPLETED'"
                      >
                        <a href="javascript:void(0)" @click="deleteAdditional(index)">
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-lg-12 col-12">
                        <a
                          href="javascript:void(0)"
                          class="text-primary px-3"
                          @click="validateFilledValues('additional')"
                          data-toggle="modal"
                          data-target="#exampleModalCenter"
                        >
                          <i class="fas fa-plus-circle font-18 mr-2"></i>
                          {{$lang.messages.add_additional_cost}}
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="card-footer text-right bg-white border-top mb-1">
                <p class="font-18 f-semi-bold mb-0">
                  {{$lang.messages.total}}
                  <span class="ml-4">
                    <vue-numeric
                      v-bind:precision="precision"
                      :separator="decimal_separator"
                      :value="order.total_amount"
                      :read-only="true"
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-9 text-right">
            <button
              type="button"
              class="btn btn-primary mr-3 mt-3"
              id="save-btn"
              @click="validateForm()"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              v-if="!order.id"
              type="button"
              class="btn btn-primary mr-3 mt-3"
              @click="validateForm('DRAFT')"
            >{{$lang.messages.save_as_draft}}</button>
            <button
              type="submit"
              class="btn btn-outline-primary mt-3"
              id="cancel-btn"
              @click="$router.go(-1)"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
